import { render, staticRenderFns } from "./tabla-buscador.vue?vue&type=template&id=8fb17572&"
import script from "./tabla-buscador.vue?vue&type=script&lang=js&"
export * from "./tabla-buscador.vue?vue&type=script&lang=js&"
import style0 from "./tabla-buscador.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports